<template>
  <FormMultiSelect
    ref="select"
    key="3"
    v-model="computedValue"
    :show-labels="false"
    :show-float-label="false"
    :config="config"
    :rules="rules"
    :query-params="internalQueryParams"
    :disabled="disabled"
    :allow-disabled-population="allowDisabledPopulation"
    v-on="$listeners"
    :data-e2e="EstateAccountCypressAttribute.inputs.ESTATE_ACCOUNT_SELECT"
  >
    <template #singleLabel="{ option }">
      <div class="is-flex p-t-3">
        <UserAvatar class="m-t-0" :user="option.user" size="25" />
        <div class="m-l-5">
          <div class="is-size-5">{{ option.user.name }}</div>
        </div>
      </div>
    </template>
    <template #option="{ option }">
      <div v-if="option.$groupLabel">{{ option.$groupLabel }}</div>
      <div v-else class="is-flex p-t-1">
        <UserAvatar :user="option.user" size="24" />
        <div class="m-l-7">
          <div class="is-size-5 m-t-2">{{ getDisplayName(option) }}</div>
        </div>
      </div>
    </template>
    <template #tag="{ option, remove }">
      <UserSelectTag :user="option.user" @remove="remove(option)" />
    </template>
  </FormMultiSelect>
</template>

<script>
import { EstateAccountSelectConfig } from '/@/modules/estateaccount/models/EstateAccountSelectConfig';
import FormMultiSelect from '/@/modules/core/form/components/FormMultiSelect.vue';
import UserAvatar from '/@/modules/user/components/presentational/UserAvatar.vue';
import { FormComputedValueMixin } from '/@/modules/core/form/mixins/FormComputedValueMixin';
import { FormSelectConfig } from '/@/modules/core/form/models/FormSelectConfig';
import { EstateAccountCypressAttribute } from '/@/modules/estateaccount/constants/EstateAccountCypressAttribute';
import { PredefinedEstateRole } from '/@/modules/role/enums/PredefinedEstateRole';
import UserSelectTag from '/@/modules/user/components/UserSelectTag.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'EstateAccountSelect',
  mixins: [FormComputedValueMixin],
  components: {
    UserSelectTag,
    FormMultiSelect,
    UserAvatar
  },
  props: {
    config: {
      type: FormSelectConfig,
      default: () => new EstateAccountSelectConfig()
    },
    queryParams: {
      type: Object,
      default: () => ({})
    },
    rules: {
      type: [Object, String]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowDisabledPopulation: {
      type: Boolean,
      default: false
    },
    showProfession: {
      type: Boolean,
      default: false
    }
  },
  static: {
    EstateAccountCypressAttribute
  },
  computed: {
    internalQueryParams() {
      return this.showProfession
        ? {
            ...this.queryParams,
            with: [...(this.queryParams.with || []), 'user.professional.profession']
          }
        : this.queryParams;
    }
  },
  methods: {
    getSelectedOptions() {
      return this.$refs.select.selectedOptions;
    },
    getDisplayName(estateAccount) {
      return (
        estateAccount.userDisplayName +
        (this.showProfession && PredefinedEstateRole.isProfessional(estateAccount.roleId)
          ? ` - ${estateAccount.displayMemberType}`
          : '')
      );
    }
  }
};
</script>
